// The archive commands (`ArchivedLoans`, `SearchArchivedLoans`, `ShowLoan`)
// are owned by @skynet/data-archive's `LoanArchiveCommands`.
export enum LoanCommands {
  Loans = 'Loans',
  Overview = 'Overview',

  Balances = 'Balances',
  BalanceHistory = 'BalanceHistory',

  AddLoan = 'AddLoan',
  UpdateLoan = 'UpdateLoan',
  HideLoan = 'HideLoan',

  LoanLiquidity = 'LoanLiquidity',
}

export interface JsonArchivedLoan {
  id: number;
  name: string;
}

export interface JsonLoan {
  id: number;
  name: string;
  activeAccountsCount?: number;
  LoanType?: number;
}

export interface JsonLoansSuccess {
  command: LoanCommands.Loans;
  list: JsonLoan[];
  companies: string[];
}

export interface JsonLinechartPart {
  date: string;
  value: number;
}

export type JsonLinechartOverview = JsonLinechartPart[];

export interface JsonLoanOrders {
  Direction: number;
  Price: number;
  Volume: number;
}

/**
 * Every depth level that can appear in liquidity data, as numeric literals
 * (mirrors `DepthNumber` in `@skynet/sky-liquidity`). Used as the key set for
 * liquidity records keyed by raw depth (e.g. loans summary `ourActualLiquidity`).
 */
export type DepthNumber =
  | 0
  | 0.1
  | 0.25
  | 0.5
  | 1
  | 1.5
  | 2
  | 5
  | 10
  | 20
  | -0.1
  | -0.25
  | -0.5
  | -1
  | -1.5
  | -2
  | -5
  | -10
  | -20;
